import { atom } from "./app-jotai";

export const ErrorMessageAtom = atom("");
